var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ProcessMenu"},[_c('FormMenu'),_c('ValidationObserver',{ref:"obsFieldsUpdate"},[_c('FormMenu',{attrs:{"FieldsForm":_vm.formUpdate,"ModelForm":_vm.formUpdModel,"method":_vm.executeProcess}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }